





















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { Babysitter, Family } from '@/interfaces/Models';

@Component
export default class NotificationFormDialog extends Vue {

    public inProgress = false;

    public title = '';
    public message = '';

    public errors = {};

    @Prop({ required: false })
    public selectedFamilies!: Family[];

    @Prop({ required: false })
    public selectedBabysitters!: Babysitter[];

    @Prop({ required: true })
    public dialog!: boolean;

    @Prop({ required: true })
    public recepientType!: 'family' | 'babysitter';

    public close() {
        this.$emit('update:dialog', !this.dialog);
    }

    public mounted() {
    }

    public async confirm() {
        this.inProgress = true;

        axios.post(api.path('v2.admin.notifications'), this.getPayload())
            .then((res) => {
                this.$toast.success(res.data.message);
                this.title = '';
                this.message = '';
                this.errors = {};
                this.$emit('update:dialog', !this.dialog);
            })
            .catch((error) => this.errors = error.response.data.errors)
            .finally(() => this.inProgress = false);
    }

    public getPayload() {
        const ids = this.recepientType === 'family' ? this.selectedFamilies.map(f => f.id) : this.selectedBabysitters.map(b => b.id);

        return {
            title: this.title,
            message: this.message,
            recepient_type: this.recepientType,
            recepient_ids: ids.length > 0 ? ids : null,
        }
    }

    public get hasFamilies(): boolean {
        return this.selectedFamilies?.length > 0;
    }

    public get hasBabysitters(): boolean {
        return this.selectedBabysitters?.length > 0;
    }

    public get selectedFamiliesCount(): number {
        return this.selectedFamilies?.length || 0;
    }

    public get selectedBabysittersCount(): number {
        return this.selectedBabysitters?.length || 0;
    }

    public get selectedCount(): number {
        return this.selectedFamiliesCount + this.selectedBabysittersCount;
    }

    public get recepientTypeText(): string {
        return this.recepientType === 'family' ? 'families' : 'babysitters';
    }
}
